import { useApiData } from '../useApiData';
import { setNavStructure } from '../../store/nav/actions';

export const useNavApi = () => {
    useApiData('/navigation', setNavStructure);
};
